import styled from "styled-components";
import Background from "../../Images/background.jpg";
/* BANNER BANNER BANNER BANNER BANNER */

export const Container = styled.div`
  background-image: url(${Background});
  height: 100vh;
`;

export const Wrapper = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  padding-top: 30px;
`;
